import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

let baseUrl = process.env.VUE_APP_API_BASE

export default {
  getSitemap (cb) {
    let url = baseUrl + 'sitemap.json'

    Vue.axios.get(url)
      .then(response => {
        return cb(response.data.data)
      })
  },
  getContent (cb) {
    let url = baseUrl + 'content.json'

    Vue.axios.get(url)
      .then(response => {
        return cb(response.data.data)
      })
  }
}
